import { useCallback } from 'react';
import { getId, lt, showSuccessAlert } from '@mews/framework';
import { Reservation } from '@mews-commander/data-access';
import { PurchaseOrderNumberFormValues } from './types';
import { useChangePurchaseOrderNumberMutation } from './useChangePurchaseOrderNumberMutation';

export const useChangePurchaseOrderNumber = (reservations: Array<Reservation>) => {
    const changePurchaseOrderNumberMutation = useChangePurchaseOrderNumberMutation(reservations.map(getId));

    const changePurchaseOrderNumber = useCallback(
        (values: PurchaseOrderNumberFormValues) =>
            changePurchaseOrderNumberMutation.mutate(values, {
                onSuccess: () => {
                    showSuccessAlert({ description: lt('ReservationPurchaseOrderNumberUpdated') });
                },
            }),
        [changePurchaseOrderNumberMutation]
    );

    return {
        isLoading: changePurchaseOrderNumberMutation.isPending,
        changePurchaseOrderNumber,
    };
};
